import React from "react";
import Wisuda from "../asset/life-after-graduate/wisuda.jpeg";

class LifeAfterGraduate extends React.Component {
  render() {
    return (
      <>
        <div className="container pt-4 pb-4 content-detail">
          <div className="header pb-4">
            <h1 className="font-PoppinsBold">
              Life <span className="font-green">After</span> Graduate 🎓🏄🏻‍♂️.
            </h1>
            <span className="font-PoppinsBold mx-1 text-grey">17-05-2025</span>
          </div>
          <div className="nav-content shadow-sm p-3 mb-5">
            <h2 className="font-PoppinsBold">Opening</h2>
            <p className="text text-justify pb-2">
              Resmi bulan ke-7 setelah melewati journey kuliah, waktu sangat
              tidak berasa sekian lama tidak tertarik menulis dan fokus dengan
              padatnya kehidupan, saya akhirnya merasakan kembali rasa burnout
              🦖, sehingga memustukan untuk menulis dan mengaktifkan lagi web
              lama saya yang hilang, sebenarnya saya juga masih malas buat bikin
              web jadi saya reuse desain web skripsi saya lalu saya modif static
              content sementara waktu, karena sedang mengumpulkan niat yang luar
              biasa 🌝. Semoga setelah ini saya konsisten menulis lagi serta
              meninggalkan jejak jejak kehidupan yang menarik bagi saya.
            </p>
            <h2 className="font-PoppinsBold">Hari Wisuda</h2>
            <p className="text text-justify pb-2">
              Tepat 10 Oktober 2025, hari itu hari saya wisuda, finnally resmi
              menamatkan kuliah yang isi nya cuman matematika, dan hitung
              hitungan yang entah membuat saya tidak tertarik sama sekali, pada
              hari itu saya sudah bekerja, kalau tidak salah hari itu sudah
              memasuki bulan ke-4 saya bekerja (Alhamdulillah saya sudah menjadi
              karyawan tetap di hari itu, berhasil melewati masa probation),
              wisuda pada pukul 19.00 malam. 16.30 saya masih mengerjakan task
              kantor saya 🐣, sehingga saya berangkat mepet dan menyebabkan toga
              saya tertinggal di mobil ketika sudah sampai tempat wisuda,
              (tolong ini jangan diikuti lebih baik cuti saat hari wisuda).
            </p>
            <img src={Wisuda} className="img-fluid pb-1" alt="Responsive" />
            <p>
              ** Lihat, jangan di contoh <b>mata ngantuk</b> karena task kantor
              yang dikerjakan sampai sore, ditambah wisuda malam, lebih baik
              cuti ketika hari wisuda.
            </p>
            <h2 className="font-PoppinsBold">Setelah Wisuda</h2>
            <p className="pb-2">
              Kehidupan setelah kuliah mungkin sedikit membosankan, berbanding
              tebalik dengan kehidupan kuliah, mungkin saya bisa pergi dari kota
              1 ke kota lainnya untuk final lomba, walaupun capek dijalan tapi
              setidak nya refreshing sedikit melihat tata letak kota orang yang
              berbeda, serta pemandangan jalanan yang berbeda setiap kota nya
              🤠, Malang, jogja, surabaya, solo, bandung dan lain lain. tapi
              memang goals hidup sudah berbeda, yang tadi nya kuliah fokus untuk
              mendapatkan perkejaan sesuai dengan yang diingikan (ini sudah
              tercapai), target saatnya terbuka 🔐 baru, langsung saja saya
              tuliskan goals saya disini (rumah Aamiin) mungkin sedikit
              imposible untuk saat ini, tapi saya yakin ini akan terbeli jika
              saya konsisten untuk saat ini dan kedepannya (Aamiin). Hari hari
              saya lewati, beragam kerjaan berhasil saya da tim kerjakan dengan
              baik, dimulai dari pentest daily, web, api, infra, sampai banking.
              semua menarik semakin hari saya semakin belajar, dari skillset,
              komunikasi, timeline, dan tryhard.
            </p>
            <h2 className="font-PoppinsBold">Burnout 😪😵</h2>
            <p className="pb-2">
              Menurut saya hal yang wajar di rasakan oleh semua orang ketika
              sudah memasuki fase bekerja, burnout mungkin menjadi hal yang
              biasa menjadi rutinitas semua orang dalam bekerja, namun kali ini
              burnout yang saya rasakan bener bener berasa kwkwkwkw, mungkin
              sedikit cerita (saya bekerja pukul 09.00 - 18.00 WIB), kemudian
              saya cukup sering mengambil freelance kembali dimulai 19.30 -
              23.30, hal ini terus saya lakukan sampai detik ini (ketika saya
              menulis saya sedang menunggu next freelance), mungkin banyak orang
              bertanya, apakah gaji yang saya dapat di bawah UMR ? sampai saya
              harus bekerja extra lebih untuk mendapatkan uang ? Alhamdulillah
              gaji yang saya dapatkan saat ini sudah sangat diatas UMR, mungkin
              kalian bisa cari sendiri range junior cyber security diindonesia.
              namun alesan saya bekerja keras tentu sudah jelas, ada pada point
              diatas yang saya targetkan, freelance (20 hari) kerja memiliki
              nilai > gaji saya. tentu ini alesan saya sering serikali
              menggaskeun freeelance. tapi saya merasakan beberapa hal positif
              yang ada, saya merasa skillset saya semakin bertambah, diskusi,
              kebutuhan yang saya butuhkan dalam bekerja saya lebih kommunikatif
              dalam hal ini, dikarenakan freelance saya harus memberikan info
              info yang saya butuhkan dan diskusi yang ada kepada abang kelas
              saya. lalu bagaimana dengan progress belajar saya ?, saat ini saya
              masih progress belajar <b>OSCP</b>, semoga saya bisa segera ujian
              dalam waktu dekat ini (Aamiin)
            </p>
            <h2 className="font-PoppinsBold">Whats Next ?</h2>
            <p className="mb-2">
              <ul>
                <li>Lulus Oscp (Amiin)</li>
                <li>
                  Karir lebih baik ? pasti, namun untuk saat ini saya masih
                  ingin fokus dikantor saya saat ini, untuk lebih berkembang
                  (Amiin)
                </li>
                <li>Kebeli Rumah (Amiin)</li>
                <li>Hadir Blackhat confrence</li>
              </ul>
            </p>
          </div>
        </div>
      </>
    );
  }
}

export default LifeAfterGraduate;
